import FormLabel from '@material-ui/core/FormLabel';

import Select from '~/components/Select';

const FieldMapping = (props) => {
  const { fields, ...restOfProps } = props;

  return (
    <>
      {fields.map((field) => {
        return (
          <MappingDropdown key={field.id} field={field} {...restOfProps} />
        );
      })}
    </>
  );
};

class MappingDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.state = this.stateFromProps(props);
    this.input = React.createRef();
  }

  fieldTypesMatch = (fieldType, key) => {
    const { salesforceObjectFields } = this.props;

    return salesforceObjectFields[key].allowed_types.some(
      (type) => fieldType === type,
    );
  };

  handleChange = (slug, selection) => {
    const newState = this.stateFromProps({
      ...this.props,
      value: selection,
    });

    this.setState(newState, () => {
      setTimeout(() => {
        this.props.changeMapping(slug, selection);
      }, 100);
    });
  };

  stateFromProps = (props) => {
    const { field, salesforceObjectFields } = this.props;
    const value = props.value || props.mapping[props.field.slug];

    const objectFields = Object.keys(salesforceObjectFields).filter((key) =>
      this.fieldTypesMatch(field.type, key),
    );

    let selectedItem;
    if (value) {
      selectedItem = objectFields.find(
        (salesforceKey) => salesforceKey.toLowerCase() === value.toLowerCase(),
      );
    }

    return {
      inputValue: selectedItem || '',
      selectedItem,
      objectFields,
      value: value || this.state.value,
    };
  };

  render() {
    const { classes, field, salesforceObjectFields, mapping } = this.props;
    const { objectFields } = this.state;

    const options = objectFields.map((field) => ({
      label: salesforceObjectFields[field].label,
      value: field,
    }));

    let value = mapping[field.slug];

    return (
      <div className={classes.fieldMappingBox}>
        <FormLabel>{field.label}</FormLabel>
        <Select
          options={options}
          onChange={(selection) => {
            this.handleChange(
              field.slug,
              selection ? selection.value : selection,
            );
          }}
          placeholder="Choose field"
          noOptionsMessage={() => 'No Salesforce fields match your query'}
          value={options.find((o) => o.value === value)}
        />
      </div>
    );
  }
}

FieldMapping.propTypes = {
  fields: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  mapping: PropTypes.object.isRequired,
  changeMapping: PropTypes.func.isRequired,
  salesforceObjectFields: PropTypes.object.isRequired,
};

export default FieldMapping;
